
import { getVariantsData } from "~/utils/shopify-utils";
import BundleProductTile from "~/components/product-tile/BundleProductTile.vue";

import { tagableMixin, campaignMixin, saleTagMixin } from "~/mixins";

export default {
  components: { BundleProductTile },
  mixins: [tagableMixin, campaignMixin, saleTagMixin],
  props: {
    product: { type: Object, required: true },
    productIndex: { type: Number, required: true },
    checked: { type: Boolean, required: false, default: false },
    currentVariantId: { type: String, default: "" },
    selectionConfirmed: { type: Boolean, default: false },
  },
  data: () => ({
    selectedVariantId: "",
    selectedVariant: null,
  }),

  computed: {
    price() {
      return this.selectedVariant?.price ?? 0;
    },
    compareAtPrice() {
      return this.selectedVariant?.compareAtPrice ?? 0;
    },
    tags() {
      return this.product?.tags ?? [];
    },
  },

  watch: {
    "product.id": {
      immediate: true,
      handler() {
        if (this.currentVariantId) return;

        const initialVariant =
          this.product?.selectedVariant ?? this.product?.variants?.[0] ?? null;

        if (initialVariant) {
          this.selectedVariant = initialVariant;
          this.selectedVariantId = initialVariant.id;
        }
      },
    },
    currentVariantId: {
      immediate: true,
      handler(newVal) {
        if (
          newVal &&
          (newVal !== this.selectedVariantId || !this.selectedVariant)
        ) {
          this.selectedVariantId = newVal;
          const found = this.product?.variants?.find(
            v =>
              v?.id != null &&
              newVal != null &&
              v.id.toString() === newVal.toString()
          );
          if (found) {
            this.selectedVariant = found;
          }
        }
      },
    },
    selectedVariantId: async function onSelectedVariantIdChange(variantId) {
      if (!variantId) return;
      this.selectedVariant = await getVariantsData(
        variantId,
        this.$getShopifyData,
        true
      );

      this.$emit("price-update", {
        variantId: this.selectedVariant?.id ?? variantId,
        price: Number(this.selectedVariant?.price ?? 0),
        compareAtPrice: Number(this.selectedVariant?.compareAtPrice ?? 0),
      });
    },
  },

  mounted() {
    this.$nuxt.$on("bundle-variant-selected", this.handleBundleVariantSelected);
  },

  beforeDestroy() {
    this.$nuxt.$off(
      "bundle-variant-selected",
      this.handleBundleVariantSelected
    );
  },

  methods: {
    visibilityChanged(isVisible) {
      if (!isVisible || !this.product?.source?.includes("searchspring-")) {
        return;
      }

      const [, tag] = this.product.source.split("searchspring-");
      this.$store.dispatch("recommendations/setVisibleProductsIds", {
        tag,
        productId: this.product.id,
      });
    },
    handleChecked(isChecked) {
      this.$emit("checked", { variantId: this.selectedVariant.id, isChecked });
    },
    handleBundleVariantSelected({ productId, variantId }) {
      if (productId !== this.product.id) return;
      this.selectedVariantId = variantId;
      this.$emit("variant-change", variantId);
      this.$emit("checked", { variantId, isChecked: true, confirmed: true });
    },
  },
};
